
import Message from './Message.vue';

export default {
  components: { Message },

  props: {
    ampId: { type: String, default: null },
    organizationId: { type: String, default: null },
    highlighted: { type: Boolean, default: false },
  },
};
